<rdo-breadcrumb></rdo-breadcrumb>
<rdo-overlay [enabled]="loading"></rdo-overlay>
<div class="container-fluid geography-page" id="geography" [rdoFillRemainingHeight]>
  <div class="row">
    <div class="col-12" id="rdo-grid">
      <ng-container *featureFlag="'flagSavedViews'">
        <rdo-saved-views
          [gridName]="gridName"
          [pageName]="pageName"
          />
      </ng-container>
      @if (!useExpandedGrid) {
        <rdo-grid-table-ng
          #grid
          [name]="gridName"
          [gridConfig]="gridConfig()"
          [pagedData]="data"
          [frozenRows]="frozenRows"
          [sorting]="sorting"
          [(paging)]="paging"
          [alwaysShowPager]="false"
          [scrollScale]="'largeScale'"
          (pageOnChange)="changePage($event)"
          (lazyLoadOnChange)="changeLazyLoad($event)"
          [totalCount]="totalCount"
          [frozenWidth]="frozenWidth"
          [showColumnSelector]="true"
          (downloadExcelClick)="exportExcel($event)"
          [useProductTypeColumnSelector]="true"
          />
      }

      @if (useExpandedGrid) {
        <rdo-grid-table-expanded-ng
          #gridExpanded
          [name]="gridName"
          [dataKey]="dataKey"
          [gridConfig]="gridConfig()"
          [rowExpansion]="gridConfig().rowExpansion"
          [pagedData]="data"
          [alwaysShowPager]="false"
          [frozenRows]="frozenRows"
          [sorting]="sorting"
          [(paging)]="paging"
          [scrollScale]="'largeScale'"
          (pageOnChange)="changePage($event)"
          (lazyLoadOnChange)="changeLazyLoad($event)"
          [totalCount]="totalCount"
          [frozenWidth]="frozenWidth" [showColumnSelector]="true"
          (downloadExcelClick)="exportExcel($event)"
          [useProductTypeColumnSelector]="true"
          />
      }
    </div>
  </div>
</div>
